import { request } from "../../Services/Api"

const BASE = "/admin_panel/perks/"

export const getPerksAdmin = (params) => request.api.get(BASE, params)

export const getPerksAdminFilterOptions = () => request.api.get(`${BASE}filter-options/`)

export const createPerkAdmin = (formData) => request.api.post(BASE, formData)

export const updatePerkAdmin = ({ id, formData }) => request.api.patch(`${BASE}${id}/`, formData)

export const deletePerkAdmin = ({ id }) => request.api.delete(`${BASE}${id}/`)

export const togglePerkVisibility = ({ id }) => request.api.patch(`${BASE}${id}/toggle-visibility/`)

export const getPerksManageOrder = () => request.api.get(`${BASE}manage-order/`)

export const reorderPerks = (data) => request.api.post(`${BASE}reorder/`, data)

export const savePerkComment = ({ id, comment_text }) =>
  request.api.post(`${BASE}${id}/comment/`, { comment_text })

export const deletePerkComment = ({ id }) => request.api.delete(`${BASE}${id}/comment/`)
